function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_573",
  "data-name": "Grupo 573",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_571",
  "data-name": "Grupo 571",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_568",
  "data-name": "Grupo 568",
  transform: "translate(0 7.434)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_567",
  "data-name": "Grupo 567"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_870",
  "data-name": "Caminho 870",
  d: "M57.684,136.2H50.89a1.521,1.521,0,0,1-1.583-1.445V133.52c0-.2,0-.347,4.711-5.457l.3-.329.3.332c4.644,5.109,4.644,5.254,4.644,5.454v1.235A1.522,1.522,0,0,1,57.684,136.2Zm-7.553-2.563v1.118a.7.7,0,0,0,.759.615h6.794a.7.7,0,0,0,.76-.615v-1.12c-.377-.508-2.579-2.97-4.126-4.677C52.748,130.665,50.515,133.126,50.131,133.637Zm-.045.064Z",
  transform: "translate(-49.307 -127.734)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_570",
  "data-name": "Grupo 570"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_569",
  "data-name": "Grupo 569"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_871",
  "data-name": "Caminho 871",
  d: "M54.252,128.666l-.3-.333c-4.644-5.109-4.644-5.254-4.644-5.453v-1.236A1.52,1.52,0,0,1,50.89,120.2h6.794a1.521,1.521,0,0,1,1.584,1.444v1.236c0,.2,0,.346-4.711,5.456Zm-4.121-5.9c.377.509,2.578,2.97,4.126,4.677,1.569-1.707,3.8-4.168,4.188-4.679v-1.118a.7.7,0,0,0-.76-.615H50.89a.7.7,0,0,0-.759.615Z",
  transform: "translate(-49.307 -120.2)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_572",
  "data-name": "Grupo 572",
  transform: "translate(1.488 10.143)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_872",
  "data-name": "Caminho 872",
  d: "M54.3,130.443l-3.471,3.916h6.942Z",
  transform: "translate(-50.826 -130.443)"
})));

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_198",
    "data-name": "Grupo 198",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.961,
    height: 15.9,
    viewBox: "0 0 9.961 15.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.2e3e0736.svg";
export { ForwardRef as ReactComponent };